import FeeDefinitionList from './FeeDefinitionList';
import FeeDefinitionEdit from './FeeDefinitionEdit';
import FeeDefinitionCreate from './FeeDefinitionCreate';

const feeDefinitions = {
	list: FeeDefinitionList,
	edit: FeeDefinitionEdit,
	create: FeeDefinitionCreate
};

export default feeDefinitions;
